// Response interceptors for the shared axios instance in ./api.js, extracted so
// their logic is unit-testable without importing axios — which does not load
// cleanly under Jest in this repo (see the note in
// containers/ReferrerSettings/saga.test.js).

/**
 * Success interceptor: a resolved response that is not 2xx is still an error.
 */
export const handleResponse = (response) => {
	if (response.status < 200 || response.status > 299) {
		throw Error(response.error);
	}
	return response;
};

/**
 * Rejection interceptor for the shared axios instance.
 *
 * On a timeout or network error there is NO `response`, so every hop of the
 * jwt-expired check must be guarded: an unguarded `error.response.data` read
 * throws a TypeError that destroys the original error before any caller (e.g.
 * the intake signing saga) can classify it — one of the ways the 2026-08-07
 * signing failure went silent. The original error is always re-thrown UNCHANGED
 * so downstream `getErrorMessage` can handle every shape.
 */
export const handleResponseError = (error) => {
	if (
		error &&
		error.response &&
		error.response.data &&
		error.response.data.error === 'jwt expired'
	) {
		const roleName = localStorage.getItem('roleName') || 'patient';
		localStorage.clear();
		window.location = `/${roleName}/signin`;
	}
	throw error;
};
